// ============================================================================
// File: infrastructureSyncApi.ts
// Purpose: Frontend API client for Infrastructure Sync Discovery (Spec 158)
// Author: Peter Dobler (Dobler Data Solutions)
// Created: 2026-06-01
// Feature: 158 - Discovery: Infrastructure Sync Visibility
// Constitution: v1.15.0
// ============================================================================

import { apiClient } from './apiClient';
import type {
  InfraSyncRunsResponse, InfraSyncRunDetail, InfraSyncStatusResponse,
} from '../../../shared/types/infrastructureSync';

export const infrastructureSyncApi = {
  async getRuns(page = 1, pageSize = 20, status?: string): Promise<InfraSyncRunsResponse> {
    const params = new URLSearchParams({ page: String(page), page_size: String(pageSize) });
    if (status) params.set('status', status);
    const res = await apiClient.get<InfraSyncRunsResponse>(`/api/infrastructure-sync/runs?${params}`);
    return res.data;
  },

  async getRunDetail(runId: string): Promise<InfraSyncRunDetail> {
    const res = await apiClient.get<InfraSyncRunDetail>(`/api/infrastructure-sync/runs/${runId}`);
    return res.data;
  },

  async getStatus(): Promise<InfraSyncStatusResponse> {
    const res = await apiClient.get<InfraSyncStatusResponse>('/api/infrastructure-sync/status');
    return res.data;
  },
};
